import { Injectable } from '@angular/core';
import { HttpClientConfig } from './http/http.config';
import { ResponsiveConfig } from './responsive/responsive.config';

@Injectable({ providedIn: 'root' })
export class AlainThemeConfig {
  http?: HttpClientConfig;
  responsive?: ResponsiveConfig;
}
